import { Injectable } from '@angular/core';
import { Observable, of, Subscription, Subject } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class SessionService {

    myUserid$: Observable<any>;
    myName$: Observable<any>;
    myPhone$: Observable<any>;
    myEmail$: Observable<any>;
    myGender$: Observable<any>;
    myRefcode$: Observable<any>;
    myToken$: Observable<any>;
    myLatitude$: Observable<any>;
    myLongitude$: Observable<any>;

    private myUseridstatus = new Subject<any>();
    private myNamestatus = new Subject<any>();
    private myPhonestatus = new Subject<any>();
    private myEmailstatus = new Subject<any>();
    private myGenderstatus = new Subject<any>();
    private myRefcodestatus = new Subject<any>();
    private myTokenstatus = new Subject<any>();
    private myLatitudestatus = new Subject<any>();
    private myLongitudestatus = new Subject<any>();

    constructor() {
        this.myUserid$ = this.myUseridstatus.asObservable();
        this.myName$ = this.myNamestatus.asObservable();
        this.myPhone$ = this.myPhonestatus.asObservable();
        this.myEmail$ = this.myEmailstatus.asObservable();
        this.myGender$ = this.myGenderstatus.asObservable();
        this.myRefcode$ = this.myRefcodestatus.asObservable();
        this.myToken$ = this.myTokenstatus.asObservable();
        this.myLatitude$ = this.myLatitudestatus.asObservable();
        this.myLongitude$ = this.myLongitudestatus.asObservable();
    }

    myLongitude(data: any) {
        this.myLongitudestatus.next(data);
        localStorage.setItem('longitude',data);
    }

    getLongitude(): Subject<any> {
        return this.myLongitudestatus;
    }

    myLatitude(data: any) {
        this.myLatitudestatus.next(data);
        localStorage.setItem('latitude',data);
    }

    getLatitude(): Subject<any> {
        return this.myLatitudestatus;
    }

    myToken(data: any) {
        this.myTokenstatus.next(data);
        localStorage.setItem('pushtoken',data);
    }

    getToken(): Subject<any> {
        return this.myTokenstatus;
    }

    myUserid(data: any) {
        this.myUseridstatus.next(data);
    }

    getUserid(): Subject<any> {
        return this.myUseridstatus;
    }

    myName(data: any) {
        this.myNamestatus.next(data);
        localStorage.setItem('name',data);
    }

    getName(): Subject<any> {
        return this.myNamestatus;
    }

    myPhone(data: any) {
        this.myPhonestatus.next(data);
        localStorage.setItem('phone',data);
    }

    getPhone(): Subject<any> {
        return this.myPhonestatus;
    }

    myEmail(data: any) {
        this.myEmailstatus.next(data);
        localStorage.setItem('email',data);
    }

    getEmail(): Subject<any> {
        return this.myEmailstatus;
    }

    myGender(data: any) {
        this.myGenderstatus.next(data);
        localStorage.setItem('gender',data);
    }

    getGender(): Subject<any> {
        return this.myGenderstatus;
    }

    myRefcode(data: any) {
        this.myRefcodestatus.next(data);        
        localStorage.setItem('my_referal_code',data);
    }

    getRefcode(): Subject<any> {
        return this.myRefcodestatus;
    }
}